
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M235.85 179.48h-18.44l23.2-71.74a5 5 0 00-.55-4.25l-26.15-40.66a5 5 0 00-8.08-.47l-20.5 25L172.08 76a5 5 0 00-8.26 3.79v23.91H86.18V79.79A5 5 0 0077.92 76L64.66 87.4l-20.5-25a5 5 0 00-8.07.47L9.94 103.49a5 5 0 00-.55 4.25l23.2 71.74H14.14a5 5 0 000 10h221.71a5 5 0 000-10zM49.34 100.57a5 5 0 00-1.74 3.79v75.12h-4.51l-23.46-72.57L40.78 74l16.3 19.9zm131.89 78.91H68.77V113.7h112.46zm21.16 0v-75.12a5 5 0 00-1.74-3.79l-7.73-6.65L209.22 74l21.15 32.89-23.47 72.59z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M122.43 141v11.46h-13.37v13.35H97.6v-13.35H84.23V141H97.6v-13.39h11.46V141h13.37zM162.25 161.51a19.34 19.34 0 11-.33-30.1 16.13 16.13 0 10.33 30.1z"}})])
          )
        }
      }
    